<template>
  <div v-if="!terminated" class="h-100 d-flex flex-column align-content-center">
    <div style="width: 100%; overflow-y: auto">
      <div v-if="loadedRatio > 0 && loadedRatio < 1"
        class="d-flex w-100 h-100 position-absolute justify-content-center">
        <div class="progress align-self-center w-300px">
          <div class="progress__bar">
            <div class="progress__value"
                 :style="{ width: loadedRatio * 100 + '%' }"></div>
          </div>
        </div>
      </div>
      <div id="pdf" >
        <pdf
          v-if="loaded"
          :src="this.launchData.activityLink"
          :page="page"
          style="margin-bottom:20px; width: 100%"
          @num-pages="pageCount = $event"
          @page-loaded="currentPage = $event"
          @loaded="onLoaded"
          @progress="loadedRatio = $event"
        ></pdf>
      </div>
    </div>
    <div v-if="loadedRatio === 1"
      class="py-3 d-flex align-content-center justify-content-between">
      <a :class="{disabled: page <= 1}"
        class="btn btn-primary font-weight-bold"
         @click="changePage(-1)">{{$t('app.pdf.previous.page')}}</a>
      <div class="align-self-center">
        <input v-model.number="page"
               type="number"
               style="width: 3em"
               @input="setPage($event)"
               :max="pageCount" min="1"> / {{pageCount}}</div>
      <a v-if="page !== pageCount"
         class="btn btn-primary font-weight-bold"
         @click="changePage(1)">{{$t('app.pdf.next.page')}}</a>
      <a v-else
         class="btn btn-primary font-weight-bold"
         @click="postData()">{{$t('app.pdf.terminate.page')}}</a>
    </div>
  </div>
  <div v-else class="d-flex h-100 align-items-center justify-content-center">
    <div class="position-absolute activity-alert d-flex flex-column"
         :class="{'clear': !organization.darkMode}">
      <span class="h6 font-weight-bold">{{$t('app.activity.completed')}}</span>
    </div>
  </div>
</template>
<script>
import pdf from 'vue-pdf';
import store from '@/store';
import {
  SET_COURSE,
  FETCH_COURSES,
  FETCH_SIMPLE_ACTIVITY,
  SEND_ACTIVITY_TRACE,
} from '@/store/actions.type';
import { mapGetters } from 'vuex';

export default {
  name: 'PdfViewer',
  components: {
    pdf,
  },
  created() {
    this.loadedRatio = 0;
    this.loaded = false;
    store.dispatch(FETCH_SIMPLE_ACTIVITY).then(() => {
      this.initPdf();
    });
  },
  computed: {
    ...mapGetters(['launchData', 'currentSession', 'course', 'organization']),
  },
  props: {
    link: String,
  },
  data() {
    return {
      loaded: false,
      gameId: '',
      currentPage: 0,
      pageCount: 0,
      loadedRatio: 0,
      page: 1,
      elapsedTime: 0,
      progress: 0,
      completed: false,
      terminated: false,
      started: false,
      src: '',
      startTime: Date.now(),
      ops: {
        sizeStrategy: 'number',
        scrollPanel: {
          scrollingX: false,
          maxHeight: window.innerHeight - 250,
        },
        bar: {
          showDelay: 500,
          onlyShowBarOnScroll: false,
          keepShow: false,
          background: 'var(--primary)',
          opacity: 0.5,
          hoverStyle: true,
          specifyBorderRadius: false,
          minSize: 0.3,
          size: '4px',
          disable: false,
        },
      },
    };
  },
  watch: {
    $route() {
      this.loadedRatio = 0;
      this.loaded = false;
      document.getElementById('pdf').style.display = 'none';
      store.dispatch(FETCH_SIMPLE_ACTIVITY).then(() => {
        this.initPdf();
      });
    },
    page() {
      if (this.page === this.pageCount) this.completed = true;
    },
  },
  methods: {
    changePage(offset) {
      const newPage = Math.max(1, Math.min(this.pageCount, this.page + offset));
      this.started = true;
      if (newPage !== this.page) {
        this.page = newPage;
        if (newPage === this.pageCount) {
          this.completed = true;
        }
      }
      this.resetScroll();
    },
    setPage(event) {
      this.page = Math.max(1, Math.min(this.pageCount, event.target.value));
      this.resetScroll();
      if (this.page === this.pageCount) {
        this.completed = true;
      }
    },
    postData() {
      if (this.completed) {
        this.terminated = true;
      }
      const progress = (this.completed
        ? 100
        : Math.round((this.page / this.pageCount) * 100));
      if (progress === null || this.gameId === '') return;
      this.progress = progress;
      this.elapsedTime += parseInt((Date.now() - this.startTime) / 1000, 10);
      this.startTime = Date.now();
      const data = {
        currentPosition: this.page,
        progress,
        gameId: this.gameId,
        session_time: this.elapsedTime,
      };
      store.dispatch(SEND_ACTIVITY_TRACE, data)
        .then(() => {
          store.dispatch(FETCH_COURSES).then(() => {
            store.dispatch(SET_COURSE, this.course.id).then(() => this.$Progress.finish());
          });
        }).catch(() => {
          this.$dialog.alert(this.$t('app.activity.commit.error'), {
            backdropClose: true,
            okText: this.$t('app.activity.commit.ok'),
          });
        });
    },
    initPdf() {
      this.loaded = true;
      this.$Progress.finish();
      const launchData = JSON.parse(this.launchData.launchData);
      this.gameId = launchData.gameId;
      this.page = launchData.currentPosition > 1 ? launchData.currentPosition : 1;
      if (launchData.session_time && launchData.session_time > 0) {
        this.elapsedTime = launchData.session_time;
      }
      this.completed = this.page === this.pageCount;
      this.started = false;
    },
    onLoaded() {
      this.startTime = Date.now();
      this.terminated = false;
      document.getElementById('pdf').style.display = 'block';
    },
    resetScroll() {
      document.getElementById('pdf').parentNode.scrollTop = 0;
    },
  },
};
</script>
